import React, { useState, useEffect } from 'react';
import { Tabla } from './Tabla';
import ObtenerPrestadores from '../functions/ObtenerPrestadores';
import PrestadorTabla from '../types/PrestadorTabla';
import { DragHandleOutlined } from '@mui/icons-material';


interface ListarPrestadoresProps {
    defaultItemsPerPage?: number;
    handleEdit: (prestador: PrestadorTabla) => void;
    handleDelete: (prestador: PrestadorTabla) => void;
    handleAdd: () => void;
    handleUbication: (prestador: PrestadorTabla) => void;
}

export const ListarPrestadores: React.FC<ListarPrestadoresProps> = ({ defaultItemsPerPage = 15, handleEdit, handleDelete, handleAdd, handleUbication, }) => {
  
  const [prestadores, setPrestadores] = useState<PrestadorTabla[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [itemsPerPage, setItemsPerPage] = useState(defaultItemsPerPage);

  const handleMostrarCredencial = (prestador: PrestadorTabla) => {
    console.log('Mostrar credencial', prestador);
  };

  const handleUbicationLocal = (prestador: PrestadorTabla) => {
    if (prestador.gpslat.trim().length === 0 || prestador.gpslon.trim().length === 0 || parseFloat(prestador.gpslat) === 0 || parseFloat(prestador.gpslon) === 0) {
      alert('El prestador no tiene cargada su ubicación');
      return;
    }
    handleUbication(prestador);
  };

  useEffect(() => {
    const fetchPaises = async () => {
      try {
        const data = await ObtenerPrestadores();
        setPrestadores(data.prestadores);
        setLoading(false);
      } catch (err) {
        setError('Error al obtener los prestadores:' + err);
        setLoading(false);
      }
    };

    fetchPaises();
  }, []);

  const columns = [
    { key: 'id', label: 'ID', align: 'center' as const },
    { key: 'cuit', label: 'CUIT', align: 'left' as const },
    { key: 'razonsocial', label: 'RAZON SOCIAL', align: 'left' as const },
    { key: 'rubro', label: 'RUBRO', align: 'left' as const },
    { key: 'domicilio', label: 'DOMICILIO', align: 'center' as const },
    { key: 'localidad', label: 'LOCALIDAD', align: 'center' as const },
    { key: 'habilitado', label: 'HABILITADO', align: 'center' as const },
  ];

  const handleEditLocal = (prestador: PrestadorTabla) => {
    handleEdit(prestador);
  };

  const handleDeleteLocal = (prestador: PrestadorTabla) => {
    handleDelete(prestador);
  };


  if (loading) return <div>Cargando...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="container mx-auto px-4 mt-5">
      <div className="flex flex-row justify-between items-center mb-3">
        <div className="flex flex-col justify-center items-center">
          <h1 className="font-metropolis text-xl font-bold">Prestadores cargados</h1>
        </div>
        <div className="flex flex-col justify-center items-center">
          <button className="vp-btn-azul-sm" onClick={handleAdd}>Nuevo Prestador</button>
        </div>
      </div>
      <Tabla columns={columns} data={prestadores} onEdit={handleEditLocal} onDelete={handleDeleteLocal} itemsPerPage={itemsPerPage} onCredencial={handleMostrarCredencial} onUbication={handleUbicationLocal} acciones={['editar','eliminar','ubicacion']}/>
    </div>
  );
};